import BangXepHangFifa from "@/components/BangXepHangFifa";

/** BXH FIFA Nữ — type=2. `data-league` = continent slug (optional). */
export default function BangXepHangFifaNu({ league: continent }) {
  return <BangXepHangFifa type={2} continent={continent || ""} />;
}
